/* eslint-disable react/no-unused-state */
import React from 'react'
import {
  FlipperContext,
  type FlipperContextValue,
  type Flips,
} from 'legacy/contexts/flipper/FlipperContext'
import { type GlobalContextValue, withGlobalContext } from 'legacy/contexts/global/GlobalContext'
import { flippersToFlipsMapping } from 'legacy/components/AccessControl/accessControl.utils'

interface Props extends GlobalContextValue {}

interface State extends FlipperContextValue {}

class FlipperProvider extends React.Component<Props, State> {
  readonly state: State = {
    flipperLoading: this.props.loading,
    flipper: this.getFlips(),
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.loading !== this.props.loading || prevProps.user !== this.props.user) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        flipperLoading: this.props.loading,
        flipper: this.getFlips(),
      })
    }
  }

  getFlips(): Flips {
    const { user } = this.props

    if (!user) {
      return {}
    }

    return flippersToFlipsMapping(user.flippers)
  }

  render() {
    return (
      <FlipperContext.Provider value={this.state}>{this.props.children}</FlipperContext.Provider>
    )
  }
}

export default withGlobalContext(FlipperProvider)
